var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgMail = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, className: "lucide lucide-mail-icon lucide-mail", viewBox: "0 0 24 24" }, props, { children: [_jsx("path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }), _jsx("rect", { width: 20, height: 16, x: 2, y: 4, rx: 2 })] }))); };
export default SvgMail;
